export default __webpack_public_path__ + "static/media/1846.65bd5d64.png";